
<section class="buy-wifi-email text-white">
    <app-error></app-error>
    <div class="modal" id="myModal" style="display: block">
       <div class="modal-dialog medium">
          <div class="modal-content">
             <div class="modal-header">
                <button type="button" class="modal-close" data-modal-close="wifi-onboard-switch"
                   (keydown.enter)="closePayConfirmationOverlay()"
                   (click)="closePayConfirmationOverlay()" tabindex="0" id="close-switch"
                   [attr.aria-label]="('close' | translate)">×</button>
                <h4 class="modal-title" id="switch-header">{{'payConfirmation.header' | translate}}</h4>
             </div>
             <div class="modal-body">
                <div class="switch-content-wrapper">                   
                   <p>Proceeding with the payment will deduct <strong>{{noOfKeys*price}}</strong> Points from your EuroBonus account and WiFi access will be provided for <strong>{{noOfKeys}}</strong> device(s)</p>                  
                   <div class="wrap-button payConfirm-confirm-container">
                      <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                         (click)="proceedToPayWithEB()">{{'payConfirmation.confirm' |
                         translate}}</button>
                   </div>
                   <div class="wrap-button payConfirm-cancel-container">
                      <button class="btn primary small small-12 switch-buy-more" id="switch-buy-more"
                         (click)="closePayConfirmationOverlay()">{{'payConfirmation.cancel' |
                         translate}}</button>
                   </div>
                </div>
             </div>
          </div>
       </div>
    </div>
 </section>